import React from 'react'
import { dateFormatterShort } from '../../utils/general'
import  corporation  from '../../assets/images/mine/corporation.png'




const ReportItem = ({report, handleShowReportInfoModal, handleShowUserModal}) => {
  return (
    <tr>
        {/* <!-- Table data --> */}
        <td>
            <div class="d-flex align-items-center position-relative">
                {/* <!-- Image --> */}
                <div class="w-60px">
                    <img src={report.profile.logo ? report.profile.logo : corporation} class="rounded" alt=""/>
                </div>
                {/* <!-- Title --> */}
                <div class="d-flex align-items-center">
            <div class="mb-0 ms-2">
            <h6 onClick={()=>handleShowUserModal(report)} class="table-responsive-title mb-0 ms-2">	
                    <span role='button' class="hoverable-span">{report.profile.full_name}</span>
                </h6>
            <div class="d-flex align-items-center mt-1">
                <i class="fas fa-table me-1"></i>
                <span class="fw-light small me-3">{report.profile.cr_number}</span>
            </div>
            </div>
        </div>
            </div>
        </td>

        {/* <!-- Table data --> */}
        <td>
        <h6 onClick={()=>handleShowReportInfoModal(report)} class="table-responsive-title mb-0">	
                    <span role='button' class="hoverable-span">{report.title}</span>
                </h6>
        </td>

        {/* <!-- Table data --> */}
        <td>{dateFormatterShort.format(Date.parse(report.created_date))}</td>




        {/* <!-- Table data --> */}
        <td>
        <div class="d-flex align-items-center">
            <div class="mb-0 ms-2">
            <div onClick={()=> handleShowReportInfoModal(report)} role="button" class="d-flex align-items-center small">
                <i class="fas fa-info me-1"></i>
                <span class="fw-light me-3"> تفاصيل التقرير</span>
            </div>
            </div>
        </div>
        </td>

 

        
    </tr>
  )
}

export default ReportItem